<i
  class="fa fa-question-circle"
  [class.text-primary]="!hasView"
  (click)="onFiledHelpIconClick()"
></i>
